import { Action, ActionCreator } from 'redux';

export enum ProjectUserManagementActionTypes {
    PROJECT_USER_GROUP_SELECTION = 'PROJECT_USER_GROUP_SELECTION'
}

export interface ProjectUserGroupSelection extends Action {
    type: ProjectUserManagementActionTypes.PROJECT_USER_GROUP_SELECTION;
    payload: {
        projectUserGroupId: string;
        projectUserGroupName: string;
    };
}

export type ProjectUserManagementAction = ProjectUserGroupSelection;

export const selectProjectUserGroup: ActionCreator<ProjectUserGroupSelection> = (
    projectUserGroupId: string,
    projectUserGroupName: string
) => {
    return {
        type: ProjectUserManagementActionTypes.PROJECT_USER_GROUP_SELECTION,
        payload: {
            projectUserGroupId,
            projectUserGroupName
        }
    };
};
